import { motion } from 'framer-motion';
import React from 'react';
import useVisibility from '../../Hooks/useVisibility';
import PopUp from '../../SharedComponents/PopUp';
import '../../Styles/Projects/ProjectsPage.css';
import VideoModal from './VideoModal';

const TravelBookingProject = () => {

    const [videoModal, toggleVideoModal] = useVisibility(false);

    return (
        <div className="flex-box booking-main-container">
            <motion.div className="flex-box project-item-content-container" initial={{ x: `-300%` }} animate={{ x: 0 }} transition={{ duration: 1 }}>
                <h2 className="project-item-title">Booking<span>.com</span></h2>
                <ul className="project-item-points">
                    <li>Booking.com is a well known Dutch online travel agency for lodging reservations & other travel products.</li>
                    <li>Developed a look alike of it, Focusing mainly on searching for hotels based on city, categorizing them with rating. Booking Airport taxi and city cab.</li>
                    <li>Done in collaboration with 3 members, In under a week.</li>
                </ul>
                <div className="flex-box projects-page-buttons-container">
                    <div className="projects-page-button project-page-button-left" onClick={() => window.open(`https://github.com/Guru-Eco/Ravi_Booking.com`)}>Code</div>
                    <div className="projects-page-button project-page-button-right" onClick={() => window.open(`https://booking-com-clone-7tdft7kta-tushartaral.vercel.app/index.html`)}>Demo</div>
                </div>
            </motion.div>
            <motion.div className="flex-box project-item-image-container" initial={{ x: `300%` }} animate={{ x: 0 }} transition={{ duration: 1 }}>
                <div className="flex-box booking-logo-background">
                    <img src={process.env.PUBLIC_URL + '/Images/travelBookingLogo.png'} onClick={toggleVideoModal} alt="booking" />
                </div>
                <div className="project-video-play-icon flex-box"></div>
                <i className="fa fa-play" aria-hidden="true" onClick={toggleVideoModal}></i>
            </motion.div>
            {
                videoModal && (
                    <div className="video-modal-main-wrapper flex-box">
                        <PopUp className="video-wrapper-container flex-box">
                            <VideoModal url={process.env.PUBLIC_URL + '/Videos/booking.mp4'} />
                        </PopUp>
                    </div>
                )
            }
        </div>
    )
}

export default TravelBookingProject
